module.exports = {
  "transpileDependencies": [
    "vuetify"
  ],
  publicPath: process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'prod' || process.env.NODE_ENV === 'homo' || process.env.NODE_ENV === 'desa'
  ? '/alison-sdk/test-panel/'
  : '/',
  configureWebpack: {
    devtool: 'source-map',
    externals: {
      AlisonJS: 'AlisonJS',
      AlisonGUI: 'AlisonGUI'
    },
    devServer: {
      https: true,
      port: 8443,
      allowedHosts: ["localhost", "localhost.certisur.net"]
    }
  }
}
